import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth-service/auth.service';
import { MessageService } from 'src/app/services/message/message.service';
import { DomainConfigService } from 'src/app/services/translate/domain-config.service';

@Component({
  selector: 'app-open',
  templateUrl: './open.component.html',
  styleUrls: ['./open.component.scss']
})
export class OpenComponent implements OnInit {
  currentUser: any;

  constructor(private route: ActivatedRoute, private domainConfig: DomainConfigService, private router: Router, private authService: AuthService, private messageService: MessageService) { }

  ngOnInit(): void {
      const token = this.route.snapshot.queryParamMap.get('token');
      const userId = this.route.snapshot.queryParamMap.get('user') || null;


      if (!token) {
        this.router.navigate(['/']);
        return;
      }
      this.authService.connectFromToken(token, userId).subscribe({
          next: (resp: any) => {
            setTimeout(() => {
              if (resp) {
                localStorage.setItem('externalToken', token);
                localStorage.setItem('currentUser', JSON.stringify(resp));
                localStorage.setItem('lang_site', 'fr');
                localStorage.setItem('lang_discuss', 'fr');
                localStorage.setItem('notifDiscussion', "2");
                localStorage.setItem('notifReport', "1");
                localStorage.setItem('notified', "all");
                localStorage.setItem('notifAtions', "1");
                localStorage.setItem('notifMode', "100");
                localStorage.setItem('notifprojectMode', "100");
                localStorage.setItem('notifModeAction', "100");
                localStorage.setItem('notifModeReunion', "100");
                localStorage.setItem('hideNav', '0');
                this.authService.initializeGuideStep(resp['step']);
                this.authService.currentUser = JSON.parse(localStorage.getItem('currentUser'));
                this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
                var secteur  = this.currentUser.comType;
                localStorage.setItem('firstConnection', resp['firstConnection']);
                var langapp  = this.currentUser.langapp;
                var langmsg  = this.currentUser.langmsg;
                var translate  = this.currentUser.translate;
                if(langapp && langapp != "") {
                  localStorage.setItem('lang_site', langapp);
                } 
                if(langmsg && langmsg != "") {
                  localStorage.setItem('lang_discuss', langmsg);
                } 
                localStorage.setItem('translate', translate);
                if(secteur === "Réseaux de Magasins"){
                  secteur = "magasins";
                } else if(secteur === "Réseaux de Clients"){
                  secteur = "clients";
                } else {
                  secteur = "groupes";
                }
                localStorage.setItem('secteur', secteur);
                this.messageService.setShowCreateProjectTuto(true);
                //this.messageService.setSound(resp['sound']);
                this.messageService.setSound(resp['sound']);
                this.messageService.setShowProjectTuto(true);
                this.messageService.setShowProjectTutobis(true);
                this.messageService.setShowNotifTuto(true);

                var userData = JSON.parse(localStorage.getItem('currentUser'));
                console.log("project: "+userData.comProject+ " subject :" +userData.comSubject)
                this.domainConfig.setConfig(userData.comProject, userData.comSubject);
                this.router.navigate(['/homes']);
                this.authService.obconnect.next(true);
              }
              this.authService.obconnect.next(true);
              this.router.navigate(['/homes']);
            }, 200); // petit effet smooth
          },
          error: () => {
            this.router.navigate(['/error']);
          }
        });
    }

}
